import { VehicleValuationProvider } from "@/api-schema-enums";

export const VEHICLE_VALUATION_PROVIDER_TRANSLATIONS = {
  [VehicleValuationProvider.Dat]: "fab:VehicleValuationProviderDAT",
} satisfies Record<VehicleValuationProvider, string>;
